/* eslint-disable jira/integration/test-id-by-folder-structure */
import React from 'react';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { TabContainer } from './TabContainer.tsx';
import { TemplatesListLoadingView } from './TemplatesListLoadingView.tsx';

const styles = cssMap({
	wrapper: {
		paddingTop: token('space.300'),
	},
});

export const PlaybookTemplatesLoadingView = (): React.JSX.Element => (
	<TabContainer>
		<Stack
			testId="playbooks-list-screen.ui.playbook-templates.edge-cases.loading"
			space="space.250"
			grow="fill"
			xcss={styles.wrapper}
		>
			<Inline>
				<Skeleton height={32} width={240} borderRadius={token('radius.small')} isShimmering />
			</Inline>
			<Stack space="space.300">
				<TemplatesListLoadingView />
				<TemplatesListLoadingView />
			</Stack>
		</Stack>
	</TabContainer>
);
